import React, { memo } from 'react';
import { formatISO } from 'date-fns';
import { useAppSelector } from 'store/hooks';
import { Spacer } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { formatAmount, formatETADateForItem } from 'utils/formatting';
import { selectInitialDepositActivity } from '../reducers/selectors';
import PotActivity from './PotActivity';
const InitialDepositSection = () => {
    const initialDeposit = useAppSelector(selectInitialDepositActivity);
    if (!initialDeposit)
        return null;
    const { activity, pot } = initialDeposit;
    const dateToUse = activity.eta || activity.depositEta;
    return (<>
      <SectionHeader horizontalMargins>Initial deposit</SectionHeader>
      <Spacer h={16}/>
      <PotActivity bounceCard hideSpaceUserAvatar pot={pot} eta={activity.eta} type={activity.type} title={activity.title} emoji={activity.emoji} amount={activity.amount} status={activity.status} timestamp={activity.timestamp} depositEta={activity.depositEta} productId={activity.potProductId} bankName={activity.potPartnerBankName} depositDetails={activity.depositDetails} isBankTransfer={activity.isBankTransfer} forceShowPositiveAmount={activity.amount.value > 0} formattedDate={dateToUse ? formatETADateForItem(formatISO(dateToUse)) : ''} formattedAmount={`${activity.amount.value > 0 ? '+' : ''}${formatAmount(activity.amount.value, activity.amount.currency, 2)}`}/>
      <Spacer h={24}/>
    </>);
};
export default memo(InitialDepositSection);
